import React, { useEffect, useState } from "react";
import { useAsyncDebounce } from "react-table";
import { COLORS } from "utils/styles";
import { IoIosSearch } from "@hacknug/react-icons/io";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import get from "lodash/get";
import { DESKTOP_SCROLL_CONTAINER, scrollTopForId } from "utils/scroll";

const GlobalFilter = ({
  config,
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  scrollTopOnChange
}) => {
  const placeholder = get(config, "search.placeholder", "");
  const [value, setValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  useEffect(() => {
    if (!globalFilter && value) {
      setValue("");
    }
  }, [globalFilter]);

  const inputProps = {
    className: "f5 border-box input-reset ba db w-100 br2 lh-copy b--black-20",
    type: "text",
    name: "text",
    style: {
      height: 36,
      textIndent: "1.75rem"
    },
    ...AUTO_ATTRS,
    placeholder,
    value: value || "",
    onChange: (e) => {
      setValue(e.target.value);
      onChange(e.target.value);

      scrollTopOnChange && scrollTopForId(DESKTOP_SCROLL_CONTAINER);
    }
  };

  return (
    <div className="flex flex-row items-center w-100">
      <IoIosSearch
        key="searchIcon"
        className="absolute pa2 z-2"
        color={COLORS.primary}
        size={22}
        // {...iconProps}
      />
      <div key="search-wrapper" className="w-100">
        <input {...inputProps} />
      </div>
    </div>
  );
};

export default GlobalFilter;
